import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/NewStudentPreallocation/GetGroupWithPaging",
    method: "get",
    params
  });
}
export function change(data) {
  return request({
    url: "/NewStudentPreallocation/ChangeRoom",
    method: "post",
    data
  });
}
export function confirm(data) {
  return request({
    url: "/NewStudentPreallocation/Confirm",
    method: "post",
    data
  });
}
export function batchConfirm(data) {
  return request({
    url: "/NewStudentPreallocation/BatchConfirm",
    method: "post",
    data
  });
}
export function startPreallocate(data) {
  return request({
    url: "/NewStudentPreallocation/StartPreallocate",
    method: "post",
    data
  });
}

export function newStudentDebit(data) {
  return request({
    url: "/NewStudentPreallocation/CreateDebitNote",
    method: "post",
    data
  });
}

export function getDebitConfig(params) {
  return request({
    url: "/NewStudentPreallocation/DebitDefaultConfig",
    method: "get",
    params
  });
}
export function refuse(data) {
  return request({
    url: "/NewStudentPreallocation/Refuse",
    method: "post",
    data
  });
}